import React, { useState, useEffect, useFocus, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { APIUrl } from '../../Helper/APIUrl.js';
import { UserParams } from '../../Helper/UserParams.js';



function DynamicMenus(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [lstCMenu, setlstCMenu] = useState([]);
    const [ParentIdlstCMenu, setParentIdlstCMenu] = useState([]);
    const [MyUserId, setMyUserId] = useState();
    const [menuReady, setMenuReady] = useState(false);

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState(null);
    const [currentPage, setCurrentPage] = useState('dashboard');


    const [active, setactive] = useState("");
    const [show, setshow] = useState("");

    const PathURL = window.location.pathname;

    const normalizePath = (path) => {
        if (!path) return '/';
        let normalized = String(path).trim();
        if (!normalized.startsWith('/')) normalized = `/${normalized}`;
        normalized = normalized.split('?')[0].split('#')[0];
        normalized = normalized.replace(/\/+$/, '');
        normalized = normalized.toLowerCase();
        return normalized || '/';
    };

    const hasPageURLMasterAccess = (menuItems) => {
        return (menuItems || []).some((item) => {
            const displayName = normalizePath(item?.DisplayName);
            const pageURL = normalizePath(item?.PageURL);
            return displayName === '/pageurlmaster' || pageURL === '/pageurlmaster';
        });
    };

    const getAllowedPaths = (menuItems) => {
        const allowedPaths = new Set(['/dashboard']);

        (menuItems || []).forEach((item) => {
            const displayName = normalizePath(item?.DisplayName);
            const pageURL = normalizePath(item?.PageURL);

            if (displayName) {
                allowedPaths.add(displayName);
            }

            if (pageURL) {
                allowedPaths.add(pageURL);
            }
        });

        if (hasPageURLMasterAccess(menuItems)) {
            ['/pageurlmaster', '/pagedetail', '/toc', '/faq', '/meta', '/tag', '/linkpage'].forEach((path) => {
                allowedPaths.add(path);
            });
        }

        return allowedPaths;
    };

    const canAccessPath = (pathName) => {
        const normalizedPath = normalizePath(pathName);

        if (normalizedPath === '/dashboard') {
            return true;
        }

        const allowedPaths = getAllowedPaths(lstCMenu);
        return allowedPaths.has(normalizedPath);
    };


    //API : Base Url + Controller Name
    const AAuthorizationsURL = APIUrl.AAuthorizations;
    const CMenuURL = APIUrl.CMenu;

    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const toggleMenu = (menuId) => {
        setActiveMenu(activeMenu === menuId ? null : menuId);
    };

    const handleNavClick = (page) => {
        setCurrentPage(page);
        setSidebarOpen(false);
    };

    const getAllCMenuEnteredinAuthorization = async () => {
        try {
            const userid = JSON.parse(localStorage.getItem('userid'));
            const Token = JSON.parse(localStorage.getItem('tcn'));

            let _lstCMenu = localStorage.getItem('lstCMenu');
            let _ParentIdlstCMenu = localStorage.getItem('ParentIdlstCMenu');
            let _lstCMenuUserId = localStorage.getItem('lstCMenuUserId');

            const hasValidCache = _lstCMenu && _lstCMenu.length > 0
                && _ParentIdlstCMenu && _ParentIdlstCMenu.length > 0
                && _lstCMenuUserId
                && String(_lstCMenuUserId) === String(userid);

            if (hasValidCache) {
                setlstCMenu(JSON.parse(_lstCMenu));
                setParentIdlstCMenu(JSON.parse(_ParentIdlstCMenu));
                setMenuReady(true);
                return; // Use cached data if available
            }
            else {
                // Cached menu belongs to a different user or is invalid.
                localStorage.removeItem('lstCMenu');
                localStorage.removeItem('ParentIdlstCMenu');
                localStorage.removeItem('lstCMenuUserId');

                const response = await fetch(`${CMenuURL}GetCMenuByUserId_entered_in_Authorization/${userid}`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: null  // No body needed
                });

                if (!response.ok) throw new Error('API failed');

                const result = await response.json();

                if (result && Array.isArray(result.data) && result.data.length > 0) {
                    const sorted = result.data.slice().sort((a, b) => (a.ChildOrder || 0) - (b.ChildOrder || 0));
                    setlstCMenu(sorted);
                    localStorage.setItem('lstCMenu', JSON.stringify(sorted));
                    localStorage.setItem('lstCMenuUserId', String(userid));
                    const UserWiseData = sorted.filter(x => String(x.ParentId) === "0");
                    setParentIdlstCMenu(UserWiseData);
                    localStorage.setItem('ParentIdlstCMenu', JSON.stringify(UserWiseData));
                } else {
                    setlstCMenu([]);
                    setParentIdlstCMenu([]);
                    localStorage.removeItem('lstCMenu');
                    localStorage.removeItem('ParentIdlstCMenu');
                    localStorage.removeItem('lstCMenuUserId');
                }
                setMenuReady(true);
            }
        } 
        catch (error) {
            console.error('API Error:', error);
            setlstCMenu([]);
            setParentIdlstCMenu([]);
            setMenuReady(true);
        }
    };


    useEffect(() => {
        setTimeout(() => {
            getAllCMenuEnteredinAuthorization();
        }, 100);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setSidebarOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const currentPath = normalizePath(location.pathname);
        setCurrentPage(currentPath);

        if (!menuReady) {
            return;
        }

        if (currentPath === '/not-authorised') {
            return;
        }

        if (!canAccessPath(currentPath)) {
            navigate('/not-authorised', { replace: true });
            return;
        }

        const matchedParent = ParentIdlstCMenu.find((parent) =>
            lstCMenu.some((child) =>
                String(child.ParentId) === String(parent.MenuId) && normalizePath(child.PageURL) === currentPath
            )
        );

        if (matchedParent) {
            setActiveMenu(matchedParent.MenuId);
        }
    }, [location.pathname, ParentIdlstCMenu, lstCMenu, menuReady, navigate]);


    return (
        <>
            <nav className="flex-1 min-h-0 px-4 py-6 space-y-2 overflow-y-auto overflow-x-hidden hide-scrollbar">
                <button
                    onClick={() => handleNavClick('/dashboard')}
                    className={`w-full flex items-start space-x-3 px-3 py-2.5 text-left rounded-lg transition-all duration-200 ${currentPage === 'dashboard'
                        ? 'bg-indigo-100 text-indigo-700 font-medium'
                        : 'text-gray-700 hover:bg-indigo-50 hover:text-indigo-700'
                        }`}
                >
                    <span className="text-xl shrink-0 leading-none">📊</span>
                    <span className="font-medium min-w-0 break-words whitespace-normal leading-snug text-left">Dashboard</span>
                </button>

                {ParentIdlstCMenu.map((lst, index) => (
                    <div key={lst.MenuId}>
                        {(
                            <>
                                {(() => {
                                    const hasActiveChild = lstCMenu.some((child) =>
                                        String(child.ParentId) === String(lst.MenuId) && normalizePath(child.PageURL) === currentPage
                                    );

                                    return (
                                        <button
                                            onClick={() => { toggleMenu(lst.MenuId) }}
                                            className={`w-full flex items-start justify-between gap-3 px-3 py-2.5 text-left rounded-lg transition-all duration-200 group ${(activeMenu === lst.MenuId || hasActiveChild)
                                                ? 'bg-indigo-100 text-indigo-700 font-medium'
                                                : 'text-gray-700 hover:bg-indigo-50 hover:text-indigo-700'
                                                }`}
                                        >
                                            <div className="flex items-start space-x-3 min-w-0 flex-1">
                                                <span className="text-xl shrink-0 leading-none"><i className={`${lst.CssClass}`} /></span>
                                                <span className="font-medium min-w-0 break-words whitespace-normal leading-snug text-left">{lst.DisplayName}</span>
                                            </div>
                                            <svg
                                                className={`w-4 h-4 shrink-0 mt-1 transition-transform duration-200 ${activeMenu === lst.MenuId ? 'rotate-90' : ''
                                                    }`}
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    );
                                })()}

                                {activeMenu === lst.MenuId && (
                                    <div className="mt-2 ml-6 max-h-56 sm:max-h-64 md:max-h-72 space-y-1 overflow-y-auto overflow-x-hidden overscroll-contain pr-1">
                                        {lstCMenu.filter(cmenus => cmenus.ParentId == lst.MenuId).map((subItem) => (
                                            <button
                                                key={subItem.MenuId}
                                                onClick={() => { navigate(subItem.PageURL); setCurrentPage(normalizePath(subItem.PageURL)); props.setCurrentPage(subItem.DisplayName) }}
                                                className={`w-full px-3 py-2 text-left text-sm rounded-lg transition-all duration-200 break-words whitespace-normal leading-snug ${currentPage === normalizePath(subItem.PageURL)
                                                    ? 'bg-indigo-100 text-indigo-700 font-medium'
                                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                                    }`}
                                            >
                                                {subItem.DisplayName}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}

            </nav>
        </>
    )
}

export default DynamicMenus